import { ConfirmDialog } from "./ConfirmDialog";
type Props = {
	visible: boolean;
	onDismiss: () => void;
	title: string;
	body: string;
	confirmCta: string;
};

export const RecordingLimitAlert = ({
	visible,
	onDismiss,
	title,
	body,
	confirmCta,
}: Props) => {
	return (
		<ConfirmDialog
			title={title}
			body={body}
			visible={visible}
			dismissCallback={onDismiss}
			confirmCallback={onDismiss}
			confirmCta={confirmCta}
		/>
	);
};
